import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import useCreatePrestacionModalidadCiclica from 'services/record/PrestacionModalidadCiclica/useCreatePrestacionModalidadCiclica';
import useUpdatePrestacionModalidadCiclicaByID from 'services/record/PrestacionModalidadCiclica/useUpdatePrestacionModalidadCiclica';
import FormInputEmail from 'components/blocks/ManagementNewForms/Inputs/FormInputEmail';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import InputRegimenFormularios from 'components/blocks/ManagementNewForms/Inputs/InputRegimenFormularios';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputTable from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import FormInputCuentaBancaria from 'components/blocks/ManagementNewForms/Inputs/FormInputCuentaBancaria';
import useBankAccounts from 'services/user/useBankAccounts';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormInfoSolicitudesDependientes from 'components/blocks/ManagementNewForms/Inputs/FormInfoSolicitudesDependientes';

const PrestacionModalidadCiclica = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm<any>({
        defaultValues: {
            DatosPrestacion: {
                PeriodoReduccion: [{ FechaDesdeReducionResolucion: null, FechaHastaReducionResolucion: null }]
            }
        }
    });
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createPrestacionModalidadCiclica, dataCreatePrestacionModalidadCiclica, errorCreatePrestacionModalidadCiclica, loadingCreatePrestacionModalidadCiclica, successCreatePrestacionModalidadCiclica } = useCreatePrestacionModalidadCiclica();
    const { dataUpdatePrestacionModalidadCiclicaById, errorUpdatePrestacionModalidadCiclicaById, loadingUpdatePrestacionModalidadCiclicaById, successUpdatePrestacionModalidadCiclicaById, updatePrestacionModalidadCiclicaById } = useUpdatePrestacionModalidadCiclicaByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    const getValue = (...values: any[]) => values.find(v => v !== undefined && v !== null);

    const watchProvinciaDatosActividad = watch("DatosActividad.EstablecimientoProvincia");
    const watchProvinciaDescDatosActividad = watch("DatosActividad.EstablecimientoProvinciaDescripcion");
    const watchCommDatosActividad = watch("DatosActividad.EstablecimientoLocalidad");
    const watchCommDescDatosActividad = watch("DatosActividad.EstablecimientoLocalidadDescripcion");

    const watchProvinciaPluriactividad = watch("Pluriactividad.PluriactividadProvincia");
    const watchProvinciaDescPluriactividad = watch("Pluriactividad.PluriactividadProvinciaDescripcion");
    const watchCommPluriactividad = watch("Pluriactividad.PluriactividadLocalidad");
    const watchCommDescPluriactividad = watch("Pluriactividad.PluriactividadLocalidadDescripcion");

    const watchProvinciaCooperativa = watch("SocioCooperativa.CooperativaProvincia");
    const watchProvinciaDescCooperativa = watch("SocioCooperativa.CooperativaProvinciaDescripcion");
    const watchCommCooperativa = watch("SocioCooperativa.CooperativaLocalidad");
    const watchCommDescCooperativa = watch("SocioCooperativa.CooperativaLocalidadDescripcion");

    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;
    // Hook para cuentas bancarias del usuario
    const { accounts: bankAccounts, getBankAccounts, getDefaultAccount } = useBankAccounts();
    const [bankAccountFromSettings, setBankAccountFromSettings] = useState(false);
    const [bankAccountsLoaded, setBankAccountsLoaded] = useState(false);
    // Cargar cuentas bancarias al iniciar
    useEffect(() => {
        const loadBankAccounts = async () => {
            await getBankAccounts();
            setBankAccountsLoaded(true);
        };
        loadBankAccounts();
        console.log(bankAccounts);
    }, []);


    const adaptApiResponseToDefaultValues = (data: any) => {
        if (!data) {
            return;
        }

        const getFirst = (...values: any[]) => values.find((value) => value !== undefined && value !== null);
        const toStringOrEmpty = (value: any) => value !== undefined && value !== null ? value.toString() : "";
        const documentacion = getValue(data?.SeccionesDocumentacion, data?.SeccionesDocumentacion)
        const datosPersonales = data?.DatosPersonales || {};
        const datosActividadLocalizacion = data?.DatosActividad_Localizacion || {};
        const socioCooperativaLocalizacion = data?.SocioCooperativa_Localizacion || {};
        const pluriactividadLocalizacion = data?.Pluriactividad_Localizacion || {};


        reset({

            // =====================================================
            // DATOS PERSONALES
            // =====================================================
            DatosPersonales: {
                SolicitanteIRPF: toStringOrEmpty(getFirst(data?.DatosPersonales_TipoIRPFVoluntario, "")),
                SolicitanteNumeroSS: getFirst(datosPersonales?.NumeroSeguridadSocial, ""),
                SolicitanteFechaNacimiento: getFirst(data?.DatosPersonales_FechaNacimiento, ""),
                SolicitanteNombre: getFirst(datosPersonales?.Nombre, ""),
                SolicitanteApellido1: getFirst(datosPersonales?.Apellido1, ""),
                SolicitanteApellido2: getFirst(datosPersonales?.Apellido2, ""),
                SolicitanteIPF: getFirst(datosPersonales?.IPF, ""),
                SolicitanteIPFTipo: toStringOrEmpty(getFirst(datosPersonales?.IPFTipo, 1)),
                SolicitanteTelefono: getFirst(datosPersonales?.Telefono, ""),
                SolicitanteFijo: getFirst(datosPersonales?.Fijo, ""),
                SolicitanteEmail: getFirst(data?.DatosPersonales_Email, ""),
                SolicitanteDomicilio: getFirst(datosPersonales?.Domicilio, ""),
                SolicitanteCodigoPostal: getFirst(datosPersonales?.CodigoPostal, ""),
                SolicitanteProvincia: getFirst(datosPersonales?.CodigoProvincia, ""),
                SolicitanteProvinciaDescripcion: getFirst(datosPersonales?.ProvinciaDescripcion, ""),
                SolicitanteComunidadCodigo: getFirst(datosPersonales?.CodigoLocalidad, ""),
            },
            // =====================================================
            // DATOS AUTÓNOMO
            // =====================================================
            DatosAutonomo: {
                RegimenSS: toStringOrEmpty(getFirst(data?.DatosPersonales_CodigoRegimen, "0")),

                TrabajadorAutonomo: {
                    ColaboradorAyudaFamiliar: getFirst(data?.DatosPersonales_AutonomoColaboradorAyudaFamiliar, false),
                    AdministradorConsejeroMercantil: getFirst(data?.DatosPersonales_AdministradorConsejeroSociedadMercantil, false),
                    SocioServiciosSociedadMercantil: getFirst(data?.DatosPersonales_SocioPrestaOtrosServiciosSociedadMercantil, false),
                    ComuneroSociosOtrasSociedades: getFirst(data?.DatosPersonales_ComuneroSocioOtrasSociedadesMercantiles, false),
                    EconomicamenteDependiente: getFirst(data?.DatosPersonales_AutonomoEconomicamenteDependiente, false),
                    CooperativaTrabajoAsociado: getFirst(data?.DatosPersonales_SocioCooperativaTrabajoAsociado, false),
                    AutonomoActividadProfesionalConjuntamente: getFirst(data?.DatosPersonales_AutonomoActividadProfesionalConjuntamente, false)
                },
                SituacionSolicitante: {
                    EsProfesionalColegiado: getFirst(data?.DatosPersonales_ProfesionalColegiado, false),
                    PrestacionesAyudasParalizacionFlota: getFirst(data?.DatosPersonales_PerceptorPrestacionesAyudasParalizacionFlota, false),
                    OtrasPrestacionesSeguridadSocial: getFirst(data?.DatosPersonales_PerceptorOtrasPrestacionesSeguridadSocial, false),
                    PensionesSeguridadSocial: getFirst(data?.DatosPersonales_PerceptorPensionesSeguridadSocial, false),
                    PrestaServiciosArt47: getFirst(data?.DatosPersonales_PrestaServiciosArt47, false),
                    PercibePrestacionCeseActividad: getFirst(data?.DatosPersonales_PercibePrestacionCeseActividad, false)
                },

                Tipo1: getFirst(data?.DatosPersonales_Tipo1, ""),
                Tipo2: getFirst(data?.DatosPersonales_Tipo2, "")
            },
            // =====================================================
            // DATOS ACTIVIDAD
            // =====================================================
            DatosActividad: {
                EmpresaNombre: getFirst(data?.DatosActividad_EmpresaNombre, ""),
                EmpresaCIF: getFirst(data?.DatosActividad_EmpresaCIF, ""),
                ExistiaEstablecimiento: getFirst(data?.DatosActividad_ExistiaEstablecimiento, false),

                EstablecimientoNombre: getFirst(data?.DatosActividad_EstablecimientoNombre, ""),
                DomicilioActividad: getFirst(datosActividadLocalizacion?.Domicilio, ""),
                EstablecimientoNumero: getFirst(datosActividadLocalizacion?.Numero, ""),
                EstablecimientoPuerta: getFirst(datosActividadLocalizacion?.Puerta, ""),
                EstablecimientoPiso: getFirst(datosActividadLocalizacion?.Piso, ""),
                EstablecimientoEscalera: getFirst(datosActividadLocalizacion?.Escalera, ""),

                EstablecimientoProvincia: getFirst(datosActividadLocalizacion?.CodigoProvincia, ""),
                EstablecimientoProvinciaDescripcion: getFirst(datosActividadLocalizacion?.ProvinciaDescripcion, ""),
                EstablecimientoLocalidad: getFirst(datosActividadLocalizacion?.CodigoLocalidad, ""),
                EstablecimientoLocalidadDescripcion: getFirst(datosActividadLocalizacion?.LocalidadDescripcion, ""),

                EstablecimientoCodigoPostal: getFirst(datosActividadLocalizacion?.CodigoPostal, ""),
                EstablecimientoTelefono: getFirst(datosActividadLocalizacion?.Telefono, ""),
                EstablecimientoCorreoElectronico: getFirst(datosActividadLocalizacion?.CorreoElectronico, ""),
                EstablecimientoActividadEconomica: getFirst(data?.DatosActividad_ActividadEconomica, ""),
                EstablecimientoNTrabajadores: toStringOrEmpty(getFirst(data?.DatosActividad_NumeroTrabajadoresUltimoAnio)),
                CorrienteObligacionesSalariales: getFirst(data?.DatosActividad_CorrienteObligacionesSalariales, false),
                EstablecimientoNTrabajadoresAfectaRed: toStringOrEmpty(getFirst(data?.DatosActividad_NumeroTrabajadoresAfectaRed))
            },
            DatosBancarios: {
                SolicitanteIBAN: getFirst(data?.DatosBancarios_IBAN?.replace(/-/g, ''), "")
            },

            // =====================================================
            // DATOS ASESORÍA
            // =====================================================
            DatosAsesoria: {
                AsesoriaNombre: getFirst(data?.DatosAsesoria_AsesoriaNombre, ""),
                AsesoriaCIF: getFirst(data?.DatosAsesoria_CIF, ""),
                AsesoriaNumeroRed: getFirst(data?.DatosAsesoria_NumeroRed, "")
            },
            // =====================================================
            // DATOS PRESTACION
            // =====================================================
            DatosPrestacion: {
                FechaRecepcionResolucion: getFirst(data?.DatosPrestacion_FechaRecepcionResolucionRed, null),
                PeriodoReduccion: [{
                    FechaDesdeReducionResolucion: getFirst(data?.DatosPrestacion_FechaDesdeReduccionActividad, null),
                    FechaHastaReducionResolucion: getFirst(data?.DatosPrestacion_FechaHastaReduccionActividad, null)
                }],
                PrimeraSolicitud: getFirst(data?.DatosPrestacion_PrimeraSolicitud, ""),
                ProrrogaNumero: toStringOrEmpty(getFirst(data?.DatosPrestacion_NumeroProrroga)),
                PorcentajeTrabajadoresAfectados: toStringOrEmpty(getFirst(data?.DatosPrestacion_PorcentajeTrabajadoresAfectadosRed)),
                IncluidoAutonomoResolucion: getFirst(data?.DatosPrestacion_IncluidoAutonomoResolucion, ""),
                IngresosDosTrimestresAntFecSolicitud: toStringOrEmpty(getFirst(data?.DatosPrestacion_IngresosDosTrimestresPrevios)),
                IngresosMismosTrimestresEjercicioAnt: toStringOrEmpty(getFirst(data?.DatosPrestacion_IngresosMismosTrimestresEjercicioAnterior)),
                PorcentajeReduccionIngresos: toStringOrEmpty(getFirst(data?.DatosPrestacion_PorcentajeReduccionIngresos)),
                IngresosAutonomoTrimestreAnt: toStringOrEmpty(getFirst(data?.DatosPrestacion_IngresosAutonomoTrimestreAnterior))
            },

            // =====================================================
            // SOCIO COOPERATIVA
            // =====================================================
            SocioCooperativa: {
                CooperativaNombre: getFirst(data?.SocioCooperativa_CooperativaNombre, ""),
                FormaJuridica: getFirst(data?.SocioCooperativa_FormaJuridica, ""),
                CooperativaCCC: getFirst(data?.SocioCooperativa_CCC, ""),
                CooperativaDomicilio: getFirst(socioCooperativaLocalizacion?.Domicilio, ""),
                CooperativaNumero: getFirst(socioCooperativaLocalizacion?.Numero, ""),
                CooperativaPuerta: getFirst(socioCooperativaLocalizacion?.Puerta, ""),
                CooperativaoPiso: getFirst(socioCooperativaLocalizacion?.Piso, ""),
                CooperativaEscalera: getFirst(socioCooperativaLocalizacion?.Escalera, ""),

                CooperativaProvincia: getFirst(socioCooperativaLocalizacion?.CodigoProvincia, ""),
                CooperativaProvinciaDescripcion: getFirst(socioCooperativaLocalizacion?.ProvinciaDescripcion, ""),
                CooperativaCodigoPostal: getFirst(socioCooperativaLocalizacion?.CodigoPostal, ""),
                CooperativaTelefono: getFirst(socioCooperativaLocalizacion?.Telefono, ""),
                CooperativaCorreoElectronico: getFirst(socioCooperativaLocalizacion?.CorreoElectronico, ""),
                CooperativaCIF: getFirst(data?.SocioCooperativa_CIF, ""),
                CooperativaLocalidad: getFirst(socioCooperativaLocalizacion?.CodigoLocalidad, ""),
                CooperativaLocalidadDescripcion: getFirst(socioCooperativaLocalizacion?.LocalidadDescripcion, ""),

                CooperativaTrabajadoresDependientes: getFirst(data?.SocioCooperativa_TrabajadoresDependientes, false),
                CooperativaTrabajadoresDependientesNumero: toStringOrEmpty(getFirst(data?.SocioCooperativa_NumeroTrabajadoresDependientes)),
                CorrienteObligacionesSalariales: getFirst(data?.SocioCooperativa_CorrienteObligacionesSalariales, false),
                EstablecimientoNTrabajadoresAfectaRed: toStringOrEmpty(getFirst(data?.SocioCooperativa_NumeroTrabajadoresAfectaRed)),

                pluriactividadEmpresaAfectadaRed: getFirst(data?.Pluriactividad_EmpresaAfectadaRed, false)
            },
            // =====================================================
            // PLURIACTIVIDAD
            // =====================================================
            Pluriactividad: {
                PluriactividadNombreEmpresa: getFirst(data?.Pluriactividad_NombreEmpresa, ""),
                PluriactividadCCC: getFirst(data?.Pluriactividad_CCC, ""),
                PluriactividadRegimen: getFirst(data?.Pluriactividad_CodigoRegimen, ""),

                PluriactividadDomicilio: getFirst(pluriactividadLocalizacion?.Domicilio, ""),
                PluriactividadNumero: getFirst(pluriactividadLocalizacion?.Numero, ""),
                PluriactividadPuerta: getFirst(pluriactividadLocalizacion?.Puerta, ""),
                PluriactividadPiso: getFirst(pluriactividadLocalizacion?.Piso, ""),
                PluriactividadEscalera: getFirst(pluriactividadLocalizacion?.Escalera, ""),

                PluriactividadProvincia: getFirst(pluriactividadLocalizacion?.CodigoProvincia, ""),
                PluriactividadProvinciaDescripcion: getFirst(pluriactividadLocalizacion?.ProvinciaDescripcion, ""),
                PluriactividadLocalidad: getFirst(pluriactividadLocalizacion?.CodigoLocalidad, ""),
                PluriactividadLocalidadDescripcion: getFirst(pluriactividadLocalizacion?.LocalidadDescripcion, ""),

                PluriactividadCodigoPostal: getFirst(pluriactividadLocalizacion?.CodigoPostal, ""),
                PluriactividadTelefono: getFirst(pluriactividadLocalizacion?.Telefono, ""),
                PluriactividadCorreoElectronico: getFirst(pluriactividadLocalizacion?.CorreoElectronico, ""),
                PluriactividadCIF: getFirst(data?.Pluriactividad_CIF, ""),

                PluriactividadFunciones: getFirst(data?.Pluriactividad_FuncionesEmpresa, ""),
                PluriactividadHechoCausante: getFirst(data?.Pluriactividad_HechoCausante, false)
            },
            Documentacion: adaptDocumentacion(documentacion),
        });
    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;
        const documentacionArray = await prepareDocumentacionArrayWithCase(data?.Documentacion || []);
        const periodoReduccion = data?.DatosPrestacion?.PeriodoReduccion?.[0] || {};

        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,

            Acepto: data?.Acepto ?? false,

            impersonadorId: dataUser?.ImpersonadorId || 0,

            datosPersonales: {
                nombre: data?.DatosPersonales?.SolicitanteNombre || "",
                apellido1: data?.DatosPersonales?.SolicitanteApellido1 || "",
                apellido2: data?.DatosPersonales?.SolicitanteApellido2 || "",
                ipf: data?.DatosPersonales?.SolicitanteIPF || "",
                ipfTipo: Number(data?.DatosPersonales?.SolicitanteIPFTipo ?? 1),
                telefono: data?.DatosPersonales?.SolicitanteTelefono || "",
                fijo: data?.DatosPersonales?.SolicitanteFijo || "",
                domicilio: data?.DatosPersonales?.SolicitanteDomicilio || "",
                codigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || "",
                provinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || "",
                codigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || "",
                codigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || "",
                localidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || "",
                numeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || ""
            },
            datosPersonales_FechaNacimiento: data?.DatosPersonales?.SolicitanteFechaNacimiento || null,
            datosPersonales_Email: data?.DatosPersonales?.SolicitanteEmail || "",
            datosPersonales_TipoIRPFVoluntario:
                data?.DatosPersonales?.SolicitanteIRPF !== "" && data?.DatosPersonales?.SolicitanteIRPF !== null && data?.DatosPersonales?.SolicitanteIRPF !== undefined
                    ? Number(data?.DatosPersonales?.SolicitanteIRPF)
                    : null,
            datosPersonales_CodigoRegimen: data?.DatosAutonomo?.RegimenSS || null,
            datosPersonales_AutonomoColaboradorAyudaFamiliar:
                data?.DatosAutonomo?.TrabajadorAutonomo?.ColaboradorAyudaFamiliar ?? false,
            datosPersonales_AdministradorConsejeroSociedadMercantil:
                data?.DatosAutonomo?.TrabajadorAutonomo?.AdministradorConsejeroMercantil ?? false,
            datosPersonales_SocioPrestaOtrosServiciosSociedadMercantil:
                data?.DatosAutonomo?.TrabajadorAutonomo?.SocioServiciosSociedadMercantil ?? false,
            datosPersonales_ComuneroSocioOtrasSociedadesMercantiles:
                data?.DatosAutonomo?.TrabajadorAutonomo?.ComuneroSociosOtrasSociedades ?? false,
            datosPersonales_AutonomoEconomicamenteDependiente:
                data?.DatosAutonomo?.TrabajadorAutonomo?.EconomicamenteDependiente ?? false,
            datosPersonales_SocioCooperativaTrabajoAsociado:
                data?.DatosAutonomo?.TrabajadorAutonomo?.CooperativaTrabajoAsociado ?? false,
            datosPersonales_AutonomoActividadProfesionalConjuntamente:
                data?.DatosAutonomo?.TrabajadorAutonomo?.AutonomoActividadProfesionalConjuntamente ?? false,
            datosPersonales_ProfesionalColegiado:
                data?.DatosAutonomo?.SituacionSolicitante?.EsProfesionalColegiado ?? false,
            datosPersonales_PerceptorPrestacionesAyudasParalizacionFlota:
                data?.DatosAutonomo?.SituacionSolicitante?.PrestacionesAyudasParalizacionFlota ?? false,
            datosPersonales_PerceptorOtrasPrestacionesSeguridadSocial:
                data?.DatosAutonomo?.SituacionSolicitante?.OtrasPrestacionesSeguridadSocial ?? false,
            datosPersonales_PerceptorPensionesSeguridadSocial:
                data?.DatosAutonomo?.SituacionSolicitante?.PensionesSeguridadSocial ?? false,
            datosPersonales_PrestaServiciosArt47:
                data?.DatosAutonomo?.SituacionSolicitante?.PrestaServiciosArt47 ?? false,
            datosPersonales_PercibePrestacionCeseActividad:
                data?.DatosAutonomo?.SituacionSolicitante?.PercibePrestacionCeseActividad ?? false,
            datosPersonales_Tipo1: data?.DatosAutonomo?.Tipo1 || "",
            datosPersonales_Tipo2: data?.DatosAutonomo?.Tipo2 || "",

            datosActividad_EmpresaNombre: data?.DatosActividad?.EmpresaNombre || "",
            datosActividad_EmpresaCIF: data?.DatosActividad?.EmpresaCIF || "",
            datosActividad_ExistiaEstablecimiento: data?.DatosActividad?.ExistiaEstablecimiento ?? false,
            datosActividad_EstablecimientoNombre: data?.DatosActividad?.EstablecimientoNombre || "",
            datosActividad_Localizacion: {
                domicilio: data?.DatosActividad?.DomicilioActividad || "",
                numero: data?.DatosActividad?.EstablecimientoNumero || "",
                puerta: data?.DatosActividad?.EstablecimientoPuerta || "",
                piso: data?.DatosActividad?.EstablecimientoPiso || "",
                escalera: data?.DatosActividad?.EstablecimientoEscalera || "",
                codigoLocalidad: data?.DatosActividad?.EstablecimientoLocalidad || "",
                localidadDescripcion: data?.DatosActividad?.EstablecimientoLocalidadDescripcion || "",
                codigoProvincia: data?.DatosActividad?.EstablecimientoProvincia || "",
                provinciaDescripcion: data?.DatosActividad?.EstablecimientoProvinciaDescripcion || "",
                codigoPostal: data?.DatosActividad?.EstablecimientoCodigoPostal || "",
                telefono: data?.DatosActividad?.EstablecimientoTelefono || "",
                correoElectronico: data?.DatosActividad?.EstablecimientoCorreoElectronico || ""
            },
            datosActividad_ActividadEconomica: data?.DatosActividad?.EstablecimientoActividadEconomica || "",
            datosActividad_NumeroTrabajadoresUltimoAnio:
                data?.DatosActividad?.EstablecimientoNTrabajadores !== "" && data?.DatosActividad?.EstablecimientoNTrabajadores !== null && data?.DatosActividad?.EstablecimientoNTrabajadores !== undefined
                    ? Number(data?.DatosActividad?.EstablecimientoNTrabajadores)
                    : null,
            datosActividad_CorrienteObligacionesSalariales: data?.DatosActividad?.CorrienteObligacionesSalariales ?? false,
            datosActividad_NumeroTrabajadoresAfectaRed:
                data?.DatosActividad?.EstablecimientoNTrabajadoresAfectaRed !== "" && data?.DatosActividad?.EstablecimientoNTrabajadoresAfectaRed !== null && data?.DatosActividad?.EstablecimientoNTrabajadoresAfectaRed !== undefined
                    ? Number(data?.DatosActividad?.EstablecimientoNTrabajadoresAfectaRed)
                    : null,

            socioCooperativa_CooperativaNombre: data?.SocioCooperativa?.CooperativaNombre || "",
            socioCooperativa_FormaJuridica: data?.SocioCooperativa?.FormaJuridica || "",
            socioCooperativa_CCC: data?.SocioCooperativa?.CooperativaCCC || "",
            socioCooperativa_Localizacion: {
                domicilio: data?.SocioCooperativa?.CooperativaDomicilio || "",
                numero: data?.SocioCooperativa?.CooperativaNumero || "",
                puerta: data?.SocioCooperativa?.CooperativaPuerta || "",
                piso: data?.SocioCooperativa?.CooperativaoPiso || "",
                escalera: data?.SocioCooperativa?.CooperativaEscalera || "",
                codigoLocalidad: data?.SocioCooperativa?.CooperativaLocalidad || "",
                localidadDescripcion: data?.SocioCooperativa?.CooperativaLocalidadDescripcion || "",
                codigoProvincia: data?.SocioCooperativa?.CooperativaProvincia || "",
                provinciaDescripcion: data?.SocioCooperativa?.CooperativaProvinciaDescripcion || "",
                codigoPostal: data?.SocioCooperativa?.CooperativaCodigoPostal || "",
                telefono: data?.SocioCooperativa?.CooperativaTelefono || "",
                correoElectronico: data?.SocioCooperativa?.CooperativaCorreoElectronico || ""
            },
            socioCooperativa_CIF: data?.SocioCooperativa?.CooperativaCIF || "",
            socioCooperativa_TrabajadoresDependientes: data?.SocioCooperativa?.CooperativaTrabajadoresDependientes ?? false,
            socioCooperativa_NumeroTrabajadoresDependientes:
                data?.SocioCooperativa?.CooperativaTrabajadoresDependientesNumero !== "" && data?.SocioCooperativa?.CooperativaTrabajadoresDependientesNumero !== null && data?.SocioCooperativa?.CooperativaTrabajadoresDependientesNumero !== undefined
                    ? Number(data?.SocioCooperativa?.CooperativaTrabajadoresDependientesNumero)
                    : null,
            socioCooperativa_CorrienteObligacionesSalariales: data?.SocioCooperativa?.CorrienteObligacionesSalariales ?? false,
            socioCooperativa_NumeroTrabajadoresAfectaRed:
                data?.SocioCooperativa?.EstablecimientoNTrabajadoresAfectaRed !== "" && data?.SocioCooperativa?.EstablecimientoNTrabajadoresAfectaRed !== null && data?.SocioCooperativa?.EstablecimientoNTrabajadoresAfectaRed !== undefined
                    ? Number(data?.SocioCooperativa?.EstablecimientoNTrabajadoresAfectaRed)
                    : null,

            pluriactividad_NombreEmpresa: data?.Pluriactividad?.PluriactividadNombreEmpresa || "",
            pluriactividad_CCC: data?.Pluriactividad?.PluriactividadCCC || "",
            pluriactividad_CodigoRegimen: data?.Pluriactividad?.PluriactividadRegimen || null,
            pluriactividad_Localizacion: {
                domicilio: data?.Pluriactividad?.PluriactividadDomicilio || "",
                numero: data?.Pluriactividad?.PluriactividadNumero || "",
                puerta: data?.Pluriactividad?.PluriactividadPuerta || "",
                piso: data?.Pluriactividad?.PluriactividadPiso || "",
                escalera: data?.Pluriactividad?.PluriactividadEscalera || "",
                codigoLocalidad: data?.Pluriactividad?.PluriactividadLocalidad || "",
                localidadDescripcion: data?.Pluriactividad?.PluriactividadLocalidadDescripcion || "",
                codigoProvincia: data?.Pluriactividad?.PluriactividadProvincia || "",
                provinciaDescripcion: data?.Pluriactividad?.PluriactividadProvinciaDescripcion || "",
                codigoPostal: data?.Pluriactividad?.PluriactividadCodigoPostal || "",
                telefono: data?.Pluriactividad?.PluriactividadTelefono || "",
                correoElectronico: data?.Pluriactividad?.PluriactividadCorreoElectronico || ""
            },
            pluriactividad_CIF: data?.Pluriactividad?.PluriactividadCIF || "",
            pluriactividad_EmpresaAfectadaRed: data?.SocioCooperativa?.pluriactividadEmpresaAfectadaRed ?? false,
            pluriactividad_HechoCausante: data?.Pluriactividad?.PluriactividadHechoCausante ?? false,
            pluriactividad_FuncionesEmpresa: data?.Pluriactividad?.PluriactividadFunciones || "",

            datosPrestacion_FechaRecepcionResolucionRed: data?.DatosPrestacion?.FechaRecepcionResolucion || null,
            datosPrestacion_FechaDesdeReduccionActividad: periodoReduccion?.FechaDesdeReducionResolucion || null,
            datosPrestacion_FechaHastaReduccionActividad: periodoReduccion?.FechaHastaReducionResolucion || null,
            datosPrestacion_PrimeraSolicitud: data?.DatosPrestacion?.PrimeraSolicitud || "",
            datosPrestacion_NumeroProrroga:
                data?.DatosPrestacion?.ProrrogaNumero !== "" && data?.DatosPrestacion?.ProrrogaNumero !== null && data?.DatosPrestacion?.ProrrogaNumero !== undefined
                    ? Number(data?.DatosPrestacion?.ProrrogaNumero)
                    : null,
            datosPrestacion_PorcentajeTrabajadoresAfectadosRed:
                data?.DatosPrestacion?.PorcentajeTrabajadoresAfectados !== "" && data?.DatosPrestacion?.PorcentajeTrabajadoresAfectados !== null && data?.DatosPrestacion?.PorcentajeTrabajadoresAfectados !== undefined
                    ? Number(data?.DatosPrestacion?.PorcentajeTrabajadoresAfectados)
                    : null,
            datosPrestacion_IncluidoAutonomoResolucion: data?.DatosPrestacion?.IncluidoAutonomoResolucion || "",
            datosPrestacion_IngresosDosTrimestresPrevios:
                data?.DatosPrestacion?.IngresosDosTrimestresAntFecSolicitud !== "" && data?.DatosPrestacion?.IngresosDosTrimestresAntFecSolicitud !== null && data?.DatosPrestacion?.IngresosDosTrimestresAntFecSolicitud !== undefined
                    ? Number(data?.DatosPrestacion?.IngresosDosTrimestresAntFecSolicitud)
                    : null,
            datosPrestacion_IngresosMismosTrimestresEjercicioAnterior:
                data?.DatosPrestacion?.IngresosMismosTrimestresEjercicioAnt !== "" && data?.DatosPrestacion?.IngresosMismosTrimestresEjercicioAnt !== null && data?.DatosPrestacion?.IngresosMismosTrimestresEjercicioAnt !== undefined
                    ? Number(data?.DatosPrestacion?.IngresosMismosTrimestresEjercicioAnt)
                    : null,
            datosPrestacion_PorcentajeReduccionIngresos:
                data?.DatosPrestacion?.PorcentajeReduccionIngresos !== "" && data?.DatosPrestacion?.PorcentajeReduccionIngresos !== null && data?.DatosPrestacion?.PorcentajeReduccionIngresos !== undefined
                    ? Number(data?.DatosPrestacion?.PorcentajeReduccionIngresos)
                    : null,
            datosPrestacion_IngresosAutonomoTrimestreAnterior:
                data?.DatosPrestacion?.IngresosAutonomoTrimestreAnt !== "" && data?.DatosPrestacion?.IngresosAutonomoTrimestreAnt !== null && data?.DatosPrestacion?.IngresosAutonomoTrimestreAnt !== undefined
                    ? Number(data?.DatosPrestacion?.IngresosAutonomoTrimestreAnt)
                    : null,

            datosBancarios_IBAN: data?.DatosBancarios?.SolicitanteIBAN
                ?.replace(/(.{4})(.{4})(.{4})(.{2})/, '$1-$2-$3-$4-') || null,

            datosAsesoria_AsesoriaNombre: data?.DatosAsesoria?.AsesoriaNombre || "",
            datosAsesoria_CIF: data?.DatosAsesoria?.AsesoriaCIF || "",
            datosAsesoria_NumeroRed: data?.DatosAsesoria?.AsesoriaNumeroRed || "",

            Documentacion: documentacionArray
        };

        if (info) {
            await createPrestacionModalidadCiclica(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            await updatePrestacionModalidadCiclicaById(dataUser?.Id, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreatePrestacionModalidadCiclica || loadingUpdatePrestacionModalidadCiclicaById} label="Cargando Formulario"></Loader>








                {/* //////////////////////////// COMIENZO FORMULARIO //////////////////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FormDatosPersonales activarSS={true} activarIRPF={true} activarFechaNacimiento={true} emailVisible={false} >
                    <FormInputEmail
                        name='DatosPersonales.SolicitanteEmail'
                        id='DatosPersonales.SolicitanteEmail'
                        label='Correo Electrónico'
                        md={12}
                        xl={12}
                        modal='Campo obligatorio a efectos de comunicación'
                        req='El correo electrónico es obligatorio'
                        disabled={false}
                    />
                </FormDatosPersonales>

                <AccordionForm title={'Datos del Autónomo'} expandedInit={false} nombreError='DatosAutonomo' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <div className={`col-xl-${12} col-md-${12} col-12`}>
                                    <div className="input-block">
                                        <label htmlFor="DatosAutonomo.RegimenSS" className="input-block__label m-0">
                                            Régimen de la
                                            Seguridad social
                                        </label>

                                        <select
                                            name="DatosAutonomo.RegimenSS"
                                            id="DatosAutonomo.RegimenSS"
                                            {...register("DatosAutonomo.RegimenSS", {

                                            })}
                                            className="form-select"
                                        >
                                            <option value={'0521'}>Régimen Especial Trabajadores Autónomos</option>
                                            <option value={'0825'}>Régimen Especial trabajadores del Mar. Áutónomos</option>
                                            <option value={'0721'}>Régimen Especial Agrario. Trabajadores por Cuenta Propia</option>
                                        </select>
                                    </div>
                                </div>





                                <FormInputCheckboxTable
                                    title={"Trabajador/a autónomo/a"}
                                    required='Debe seleccionar al menos una opción.'
                                    col={12}
                                    labels={[
                                        "Autónomo/a colaborador/a ayuda familiar",
                                        "Administrador o Consejero de una Sociedad Mercantil",
                                        "Socio que preste otros servicios a una Sociedad Mercantil",
                                        "Comunero o socios de otras Sociedades No Mercantiles",
                                        "Trabajador/a autónomo/a económicamente dependiente (TRADE)",
                                        "Socio trabajador de cooperativa de trabajo asociado",
                                        "Trabajador/a autónomo/a que ejerce su actividad profesional conjuntamente"
                                    ]}
                                    names={[
                                        "DatosAutonomo.TrabajadorAutonomo.ColaboradorAyudaFamiliar",
                                        "DatosAutonomo.TrabajadorAutonomo.AdministradorConsejeroMercantil",
                                        "DatosAutonomo.TrabajadorAutonomo.SocioServiciosSociedadMercantil",
                                        "DatosAutonomo.TrabajadorAutonomo.ComuneroSociosOtrasSociedades",
                                        "DatosAutonomo.TrabajadorAutonomo.EconomicamenteDependiente",
                                        "DatosAutonomo.TrabajadorAutonomo.CooperativaTrabajoAsociado",
                                        "DatosAutonomo.TrabajadorAutonomo.AutonomoActividadProfesionalConjuntamente"
                                    ]}
                                />


                                <FormInputCheckboxTable
                                    title="Situaciones del solicitante"
                                    labels={[
                                        "Es profesional colegiado",
                                        "Es perceptor/a de prestaciones de ayudas por paralización de la flota",
                                        "Es perceptor de otras prestaciones de la Seguridad Social",
                                        "Es perceptor/a de pensiones de la Seguridad Social",
                                        "Presta servicios para otra empresa",
                                        "Percibe prestación de cese de actividad o mecanismo de sostenibilidad"
                                    ]}
                                    names={[
                                        "DatosAutonomo.SituacionSolicitante.EsProfesionalColegiado",
                                        "DatosAutonomo.SituacionSolicitante.PrestacionesAyudasParalizacionFlota",
                                        "DatosAutonomo.SituacionSolicitante.OtrasPrestacionesSeguridadSocial",
                                        "DatosAutonomo.SituacionSolicitante.PensionesSeguridadSocial",
                                        "DatosAutonomo.SituacionSolicitante.PrestaServiciosArt47",
                                        "DatosAutonomo.SituacionSolicitante.PercibePrestacionCeseActividad"
                                    ]}
                                    required="Debes responder al menos una opción"
                                    col={12}
                                    modal={["", "", "", "", "Presta servicios para otra empresa por cuenta propia o ajena que no esté Afectada por mecanismo de red (Art. 47.bis Estatuto de los Trabajadores).", ""]}

                                />
                                <AccordionDisplay dataUser={dataUser} visibility={watch('DatosAutonomo.SituacionSolicitante.OtrasPrestacionesSeguridadSocial') === true} fields={['DatosAutonomo.Tipo1']}>
                                    <FormInputText
                                        name='DatosAutonomo.Tipo1'
                                        id='DatosAutonomo.Tipo1'
                                        label='Tipo'
                                        md={12}
                                        xl={12}
                                        disabled={false}
                                        modal='Tipo sobre si es perceptor de otras prestaciones de la Seguridad Social'
                                    />
                                </AccordionDisplay>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('DatosAutonomo.SituacionSolicitante.PensionesSeguridadSocial') === true} fields={['DatosAutonomo.Tipo2']}>
                                    <FormInputText
                                        name='DatosAutonomo.Tipo2'
                                        id='DatosAutonomo.Tipo2'
                                        label='Tipo'
                                        md={12}
                                        xl={12}
                                        disabled={false}
                                        modal='Tipo sobre si es perceptor de pensiones de la Seguridad Social'
                                    />
                                </AccordionDisplay>

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>


                {/* ------------------ DATOS ACTIVIDAD APARTADO 2 ------------------ */}
                <AccordionForm title={'Datos de la Actividad'} expandedInit={false} nombreError='DatosActividad' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>
                                <FormInputText
                                    name='DatosActividad.EmpresaNombre'
                                    id='DatosActividad.NombreEmpresa'
                                    label='Nombre de la empresa propia'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosActividad.EmpresaCIF'
                                    id='DatosActividad.EmpresaCIF'
                                    label='CIF de la empresa propia'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />


                                <FormInputCheckboxTable
                                    title={"Marque si existia un establecimiento abierto al público"}

                                    col={12}
                                    labels={[
                                        "Existía establecimiento abierto al público",
                                    ]}
                                    names={[
                                        "DatosActividad.ExistiaEstablecimiento",
                                    ]}

                                />

                                <FormInputText
                                    name='DatosActividad.EstablecimientoNombre'
                                    id='DatosActividad.EstablecimientoNombre'
                                    label='Nombre del establecimiento'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosActividad.DomicilioActividad'
                                    id='DatosActividad.DomicilioActividad'
                                    label='Domicilio de la Actividad'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoNumero'
                                    id='DatosActividad.EstablecimientoNumero'
                                    label='Número'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoPuerta'
                                    id='DatosActividad.EstablecimientoPuerta'
                                    label='Puerta'
                                    md={3}
                                    xl={3}
                                    disabled={false}

                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoPiso'
                                    id='DatosActividad.EstablecimientoPiso'
                                    label='Piso'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoEscalera'
                                    id='DatosActividad.EstablecimientoEscalera'
                                    label='Esc./Bloque'
                                    md={3}
                                    xl={3}

                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'DatosActividad.EstablecimientoProvincia'}
                                        watchProvinceDescription={watchProvinciaDescDatosActividad}
                                        idDescription={'DatosActividad.EstablecimientoProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaDatosActividad}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaDatosActividad}
                                        watchCommunityCode={watchCommDatosActividad}
                                        watchCommunityDescription={watchCommDescDatosActividad}
                                        idCode={'DatosActividad.EstablecimientoLocalidad'}
                                        idDescription={'DatosActividad.EstablecimientoLocalidadDescripcion'}
                                        filterByProvince={true}
                                        disabled={false}
                                    />
                                </div>

                                <FormInputText
                                    name='DatosActividad.EstablecimientoCodigoPostal'
                                    id='DatosActividad.EstablecimientoCodigoPostal'
                                    label='Codigo Postal'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosActividad.EstablecimientoTelefono'
                                    id='DatosActividad.EstablecimientoTelefono'
                                    label='Teléfono'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputEmail
                                    name='DatosActividad.EstablecimientoCorreoElectronico'
                                    id='DatosActividad.EstablecimientoCorreoElectronico'
                                    label='Correo Electrónico'
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosActividad.EstablecimientoActividadEconomica'
                                    id='DatosActividad.EstablecimientoActividadEconomica'
                                    label='Actividad Económica'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoNTrabajadores'
                                    id='DatosActividad.EstablecimientoNTrabajadores'
                                    label='Nº de trabajadores/as por cuenta ajena en el último año'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />
                                <FormInputCheckboxTable
                                    title={"Marque si la empresa está al corriente de las obligaciones salariales con los trabajadores"}
                                    col={12}
                                    labels={[
                                        "Marque si procede",
                                    ]}
                                    names={[
                                        "DatosActividad.CorrienteObligacionesSalariales",
                                    ]}
                                />
                                <FormInputText
                                    name='DatosActividad.EstablecimientoNTrabajadoresAfectaRed'
                                    id='DatosActividad.EstablecimientoNTrabajadoresAfectaRed'
                                    label='Nº de trabajadores a los que afecta el Mecanismo Red'
                                    md={12}
                                    xl={12}

                                    disabled={false}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>


                {/* ------------------ COOPERATIVA SOCIO APARTADO 3 ------------------ */}
                <AccordionForm title={'Socio/a trabajador/a de cooperativa de trabajo asociado o similares'} expandedInit={false} nombreError='SocioCooperativa' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>
                                <FormInputText
                                    name='SocioCooperativa.CooperativaNombre'
                                    id='SocioCooperativa.CooperativaNombre'
                                    label='Nombre de la Cooperativa'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.FormaJuridica'
                                    id='SocioCooperativa.FormaJuridica'
                                    label='Forma Jurídica'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.CooperativaCCC'
                                    id='SocioCooperativa.CooperativaCCC'
                                    label='CCC'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    maxLength={11}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaDomicilio'
                                    id='SocioCooperativa.CooperativaDomicilio'
                                    label='Domicilio de la Actividad'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.CooperativaNumero'
                                    id='SocioCooperativa.CooperativaNumero'
                                    label='Número'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaPuerta'
                                    id='SocioCooperativa.CooperativaPuerta'
                                    label='Puerta'
                                    md={3}
                                    xl={3}
                                    disabled={false}

                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaoPiso'
                                    id='SocioCooperativa.CooperativaPiso'
                                    label='Piso'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaEscalera'
                                    id='SocioCooperativa.CooperativaEscalera'
                                    label='Esc./Bloque'
                                    md={3}
                                    xl={3}

                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />


                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'SocioCooperativa.CooperativaProvincia'}
                                        watchProvinceDescription={watchProvinciaDescCooperativa}
                                        idDescription={'SocioCooperativa.CooperativaProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaCooperativa}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaCooperativa}
                                        watchCommunityCode={watchCommCooperativa}
                                        watchCommunityDescription={watchCommDescCooperativa}
                                        idCode={'SocioCooperativa.CooperativaLocalidad'}
                                        idDescription={'SocioCooperativa.CooperativaLocalidadDescripcion'}
                                        filterByProvince={true}
                                        disabled={false}
                                    />
                                </div>

                                <FormInputText
                                    name='SocioCooperativa.CooperativaCodigoPostal'
                                    id='SocioCooperativa.CooperativaCodigoPostal'
                                    label='Codigo Postal'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.CooperativaTelefono'
                                    id='SocioCooperativa.CooperativaTelefono'
                                    label='Teléfono'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputEmail
                                    name='SocioCooperativa.CooperativaCorreoElectronico'
                                    id='SocioCooperativa.CooperativaCorreoElectronico'
                                    label='Correo Electrónico'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />


                                <FormInputText
                                    name='SocioCooperativa.CooperativaCIF'
                                    id='SocioCooperativa.CooperativaCIF'
                                    label='CIF de la empresa'
                                    md={6}
                                    xl={6}
                                    
                                    disabled={false}
                                />
                                <FormInputCheckboxTable
                                    title={"Marque si la empresa tiene trabajadores dependientes"}
                                    col={12}
                                    labels={[
                                        "Marque si procede",
                                    ]}
                                    names={[
                                        "SocioCooperativa.CooperativaTrabajadoresDependientes",
                                    ]}
                                />
                                <FormInputCheckboxTable
                                    title={"Marque si la empresa está al corriente de las obligaciones salariales con los trabajadores"}
                                    col={12}
                                    labels={[
                                        "Marque si procede",
                                    ]}
                                    names={[
                                        "SocioCooperativa.CorrienteObligacionesSalariales",
                                    ]}
                                />
                                <FormInputText
                                    name='SocioCooperativa.CooperativaTrabajadoresDependientesNumero'
                                    id='SocioCooperativa.CooperativaTrabajadoresDependientesNumero'
                                    label='Número de trabajadores dependientes'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputText
                                    name='SocioCooperativa.EstablecimientoNTrabajadoresAfectaRed'
                                    id='SocioCooperativa.EstablecimientoNTrabajadoresAfectaRed'
                                    label='Nº de trabajadores a los que afecta el Mecanismo Red'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />
                            </FieldsetContainer>


                        </div>
                    </div>
                </AccordionForm>

                {/* ------------------ PLURIACTIVIDAD APARTADO 4 ------------------ */}
                <AccordionForm title={'Pluriactividad'} expandedInit={false} nombreError='Pluriactividad' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputText
                                    name='Pluriactividad.PluriactividadNombreEmpresa'
                                    id='Pluriactividad.PluriactividadNombreEmpresa'
                                    label='Nombre de la Empresa'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                    req={watch('Pluriactividad.PluriactividadHechoCausante') === true ? 'El Nombre de la Empresa es obligatorio' : null}
                                />

                                <FormInputText
                                    name='Pluriactividad.PluriactividadCCC'
                                    id='Pluriactividad.PluriactividadCCC'
                                    label='CCC'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    maxLength={11}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                    req={watch('Pluriactividad.PluriactividadHechoCausante') === true && watch('Pluriactividad.PluriactividadCIF') === '' ? 'Debe cumplimentar el CCC en caso de que no haber rellenado el CIF' : null}
                                />

                                <InputRegimenFormularios
                                    name={'Pluriactividad.PluriactividadRegimen'}
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                    isAutonomo={null}

                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadDomicilio'
                                    id='Pluriactividad.PluriactividadDomicilio'
                                    label='Domicilio'
                                    md={6}
                                    xl={6}

                                    disabled={false}
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadNumero'
                                    id='Pluriactividad.PluriactividadNumero'
                                    label='Número'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadPuerta'
                                    id='Pluriactividad.PluriactividadPuerta'
                                    label='Puerta'
                                    md={3}
                                    xl={3}
                                    disabled={false}

                                    patternMessage='Solo se permiten numeros enteros'
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadPiso'
                                    id='Pluriactividad.PluriactividadPiso'
                                    label='Piso'
                                    md={3}
                                    xl={3}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadEscalera'
                                    id='Pluriactividad.PluriactividadEscalera'
                                    label='Esc./Bloque'
                                    md={3}
                                    xl={3}

                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />


                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'Pluriactividad.PluriactividadProvincia'}
                                        watchProvinceDescription={watchProvinciaDescPluriactividad}
                                        idDescription={'Pluriactividad.PluriactividadProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaPluriactividad}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaPluriactividad}
                                        watchCommunityCode={watchCommPluriactividad}
                                        watchCommunityDescription={watchCommDescPluriactividad}
                                        idCode={'Pluriactividad.PluriactividadLocalidad'}
                                        idDescription={'Pluriactividad.PluriactividadLocalidadDescripcion'}
                                        filterByProvince={true}
                                        disabled={false}
                                    />
                                </div>


                                <FormInputText
                                    name='Pluriactividad.PluriactividadCodigoPostal'
                                    id='Pluriactividad.PluriactividadCodigoPostal'
                                    label='Codigo Postal'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputText
                                    name='Pluriactividad.PluriactividadTelefono'
                                    id='Pluriactividad.PluriactividadTelefono'
                                    label='Teléfono'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />

                                <FormInputEmail
                                    name='Pluriactividad.PluriactividadCorreoElectronico'
                                    id='Pluriactividad.PluriactividadCorreoElectronico'
                                    label='Correo Electrónico'
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='Pluriactividad.PluriactividadCIF'
                                    id='Pluriactividad.PluriactividadCIF'
                                    label='CIF de la Empresa'
                                    md={6}
                                    xl={6}
                                   
                                    disabled={false}
                                    req={watch('Pluriactividad.PluriactividadHechoCausante') === true && watch('Pluriactividad.PluriactividadCCC') === '' ? 'Debe introducir un CIF en caso de no haber rellenado el CCC' : null}
                                />
                                <FormInputText
                                    name='Pluriactividad.PluriactividadFunciones'
                                    id='Pluriactividad.PluriactividadFunciones'
                                    label='Funciones que desempeña en la Empresa'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputCheckboxTable
                                    title={"Marque si la empresa está afectada por el Mecanismo Red"}
                                    col={12}
                                    labels={[
                                        "Marque si procede",
                                    ]}
                                    names={[
                                        "SocioCooperativa.pluriactividadEmpresaAfectadaRed",
                                    ]}
                                />
                            </FieldsetContainer>


                            <div className='px-3'>
                                <FormInputCheckboxTable
                                    title={"Pluriactividad en el momento del hecho causante de la prestación por cese de actividad"}
                                    col={12}
                                    labels={[
                                        "¿Pluriactividad en el Momento?",
                                    ]}
                                    names={[
                                        "Pluriactividad.PluriactividadHechoCausante",
                                    ]}
                                />
                            </div>

                        </div>
                    </div>
                </AccordionForm>


                {/* ------------------ DatosPrestacion APARTADO 5 ------------------ */}
                <AccordionForm title={'Datos de la prestación'} expandedInit={false} nombreError='DatosPrestacion' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputFecha
                                    name='DatosPrestacion.FechaRecepcionResolucion'
                                    id='DatosPrestacion.FechaRecepcionResolucion'
                                    label='Fecha de recepción de la resolución'
                                    md={4}
                                    xl={4}
                                    modal='Fecha recepción Resolución Autoridad Laboral Autorizando Mecanismo Red'
                                />

                                <FormInputTable
                                    name="DatosPrestacion.PeriodoReduccion"
                                    heads={["Fecha desde la reducción", "Fecha hasta la reducción"]}
                                    nameHeads={["FechaDesdeReducionResolucion", "FechaHastaReducionResolucion"]}
                                    removeButton={false}
                                    addButton={false}
                                    widthColumn={[1, 1]}
                                    validateFunction={undefined}
                                    inputType={[4, 4]}
                                    arrayModal={[
                                        'Fecha desde la reducción y fecha hasta la reducción comprende el periodo de reducción de la actividad según resolución  ',
                                        'Fecha desde la reducción y fecha hasta la reducción comprende el periodo de reducción de la actividad según resolución  '
                                    ]}
                                />

                                {/* Primera solicitud */}
                                <FormInputText
                                    name='DatosPrestacion.PrimeraSolicitud'
                                    id='DatosPrestacion.PrimeraSolicitud'
                                    label='Primera solicitud'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosPrestacion.ProrrogaNumero'
                                    id='DatosPrestacion.ProrrogaNumero'
                                    label='Número de prórroga'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten números enteros'
                                    disabled={false}
                                    modal='indicar número de prórroga solicitada, 1º 2º o 3º'
                                />

                                {/* Porcentajes */}
                                <FormInputText
                                    name='DatosPrestacion.PorcentajeTrabajadoresAfectados'
                                    id='DatosPrestacion.PorcentajeTrabajadoresAfectados'
                                    label='Porcentaje de trabajadores afectados por mecanismo red'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                                    patternMessage='Introduce un decimal valido usando "." o "," '
                                    disabled={false}
                                    modal='Porcentaje de trabajadores afectados en la empresa por la aplicación del Mecanismo Red'
                                />

                                <FormInputText
                                    name='DatosPrestacion.PorcentajeReduccionIngresos'
                                    id='DatosPrestacion.PorcentajeReduccionIngresos'
                                    label='Porcentaje de reducción de ingresos entre ejercicios'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                                    patternMessage='Introduce un decimal valido usando "." o "," '
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosPrestacion.IncluidoAutonomoResolucion'
                                    id='DatosPrestacion.IncluidoAutonomoResolucion'
                                    label='Está incluido el autónomo en la resolución'
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                />

                                {/* Ingresos */}
                                <FormInputText
                                    name='DatosPrestacion.IngresosDosTrimestresAntFecSolicitud'
                                    id='DatosPrestacion.IngresosDosTrimestresAntFecSolicitud'
                                    label='Ingresos de los dos Trimestres consecutivos anteriores a la fecha de la solicitud'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                                    patternMessage='Introduce un decimal valido usando "." o "," '
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosPrestacion.IngresosMismosTrimestresEjercicioAnt'
                                    id='DatosPrestacion.IngresosMismosTrimestresEjercicioAnt'
                                    label='Ingresos mismos trimestres del ejercicio anterior'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                                    patternMessage='Introduce un decimal valido usando "." o "," '
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosPrestacion.IngresosAutonomoTrimestreAnt'
                                    id='DatosPrestacion.IngresosAutonomoTrimestreAnt'
                                    label='Ingresos del autónomo en el trimestre anterior'
                                    md={4}
                                    xl={4}
                                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                                    patternMessage='Introduce un decimal valido usando "." o "," '
                                    disabled={false}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>


                <AccordionForm title={'Datos Bancarios'} expandedInit={false} nombreError='DatosBancarios' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            {bankAccountFromSettings && (
                                <div className="alert alert-info mb-3" style={{
                                    backgroundColor: '#D8F1FF',
                                    border: '1px solid #409CCE',
                                    borderRadius: '4px',
                                    padding: '12px 16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#409CCE">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                                    </svg>
                                    <span style={{ color: '#4E4E4E', fontSize: '14px' }}>
                                        Datos bancarios cargados desde tu configuracion.
                                        <a href="/ajustes" style={{ color: '#409CCE', marginLeft: '4px' }}>
                                            Modificar en Ajustes
                                        </a>
                                    </span>
                                </div>
                            )}
                            <FieldsetContainer legend="Datos Bancarios" disabled={false}>

                                <FormInputCuentaBancaria
                                    id='DatosBancarios.SolicitanteIBAN'
                                    name='DatosBancarios.SolicitanteIBAN'
                                    xl={12}
                                    md={12}
                                    placeholder=''
                                    req='Falta el Número de Cuenta Bancaria' />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Datos de la asesoría'} expandedInit={false} nombreError='DatosAsesoria'  >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Datos Asesoria" disabled={false}>

                                <FormInputText
                                    name='DatosAsesoria.AsesoriaNombre'
                                    id='DatosAsesoria.AsesoriaNombre'
                                    label='Nombre de la Asesoria'
                                    md={12}
                                    xl={12}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosAsesoria.AsesoriaCIF'
                                    id='DatosAsesoria.AsesoriaCIF'
                                    label='CIF de la asesoría'
                                    md={6}
                                    xl={6}
                                    
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosAsesoria.AsesoriaNumeroRed'
                                    id='DatosAsesoria.AsesoriaNumeroRed'
                                    label='Nº RED'
                                    md={6}
                                    xl={6}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                    disabled={false}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Documentacion'} expandedInit={false} nombreError='Documentacion' totalSize={totalSize} maxSize={MAX_SIZE_MB} >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FormArrayArchivosReducidos
                                name={'Documentacion'}
                                urlArchivos={dataUser?.Documentacion?.map(d => d?.SasUri) || []}
                                setTotalSize={setTotalSize}
                            />

                        </div>
                    </div>
                </AccordionForm>



                {/* ////////////// FINAL FORMULARIO ////////////// */}

                <FormInfoSolicitudesDependientes data={dataUser} />

                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreatePrestacionModalidadCiclica}
                    successUpdate={successUpdatePrestacionModalidadCiclicaById}
                    errorCreate={errorCreatePrestacionModalidadCiclica}
                    errorUpdate={errorUpdatePrestacionModalidadCiclicaById}
                    datosAPI={datosAPI}
                    totalSizeDocs={totalSize}
                    info={info}
                    MaxSizeMB={MAX_SIZE_MB}
                    label='Declara bajo su responsabilidad que son ciertos los datos que se consignan en la presente declaración y que, al día de la fecha, los datos declarados siguen siendo vigentes y asimismo quedo enterado de la obligación de comunicar a la Mutua cualquier variación de los datos en ella expresados, que reclamación de la prestación que hubiera dado lugar.'
                >
                    <p>
                        De conformidad con lo establecido en el Real Decreto Legislativo 8/2015 (Disposición Adicional Cuadragésima Octava,
                        punto 15, apartado 2) autorizo expresamente a Solimat, Mutua Colaboradora con la Seguridad Social nº 72 a recabar
                        los datos necesarios, tanto de la empresa como míos propios, de las administraciones públicas, que sean necesarios
                        para la concurrencia de los requisitos exigidos para acceder a la prestación.
                    </p>
                    <p className='mt-3'>
                        <strong>I.-</strong> En cualquier momento usted podrá dirigirse a nuestras oficinas y/o consultar nuestra página web.
                        Estamos a su plena disposición para asesorarle e informarle.
                    </p>

                    <p>
                        <strong>II.-</strong> Este documento, junto con el resto de los que integran el expediente tramitado por la Mutua,
                        podrá ser presentado por la Mutua ante la Inspección de Trabajo y la Seguridad Social cuando se detecten
                        contradicciones en las declaraciones y certificaciones, de acuerdo con lo dispuesto en la normativa vigente.
                    </p>

                    <p>
                        <strong>III.-</strong> De no estar usted de acuerdo con las decisiones de la Mutua, podrá efectuar reclamación previa
                        ante ese órgano gestor antes de acudir al órgano jurisdiccional del orden social competente.
                    </p>

                    <p>
                        <strong>IV.-</strong> Son obligaciones de los trabajadores autónomos, así como de los solicitantes y beneficiarios de la
                        prestación que active el mecanismo RED en su modalidad cíclica:
                    </p>

                    <div className='ml-4'>
                        <p>
                            <strong>a)</strong> Solicitar a la misma Mutua de Accidentes de Trabajo y Enfermedades Profesionales de la Seguridad Social
                            con la que tengan concertadas contingencias profesionales la cobertura de protección por cese de actividad.
                        </p>

                        <p>
                            <strong>b)</strong> Mantenerse de alta en el régimen correspondiente durante toda la vigencia de la prestación.
                        </p>

                        <p>
                            <strong>c)</strong> Cumplir las obligaciones adquiridas al adoptar el mecanismo RED.
                        </p>

                        <p>
                            <strong>d)</strong> Incorporarse a la actividad cuando se acuerde el levantamiento de las medidas adoptadas en el
                            mecanismo RED y mantenerse en el desarrollo de la actividad al menos seis meses consecutivos.
                        </p>

                        <p>
                            <strong>e)</strong> Proporcionar la documentación e información que resulten necesarias a los efectos del reconocimiento,
                            suspensión, extinción o reanudación de la prestación.
                        </p>

                        <p>
                            <strong>f)</strong> Mantenerse durante el percibo de la prestación al corriente en las cotizaciones a la Seguridad Social
                            de los trabajadores de la empresa.
                        </p>

                        <p>
                            <strong>g)</strong> Solicitar la baja en la prestación por cese de actividad cuando se produzcan situaciones de suspensión
                            o extinción del derecho, o cuando se dejen de reunir los requisitos exigidos para su percepción.
                        </p>

                        <p>
                            <strong>h)</strong> No trabajar por cuenta propia (excepto la actividad que motiva la solicitud de la prestación) ni por
                            cuenta ajena durante la percepción de la prestación.
                        </p>

                        <p>
                            <strong>i)</strong> No percibir de forma simultánea prestaciones derivadas de dos o más mecanismos RED, sin perjuicio del
                            derecho de opción por la más beneficiosa.
                        </p>

                        <p>
                            <strong>j)</strong> Reintegrar las prestaciones indebidamente percibidas.
                        </p>
                    </div>

                    <p>
                        <strong>V.-</strong> La prestación para la sostenibilidad de la actividad de las personas trabajadoras autónomas de un sector
                        de actividad afectado por el mecanismo RED de flexibilidad y estabilización del empleo, en su modalidad cíclica,
                        se encuentra regulada en el Real Decreto Legislativo 8/2015, de 30 de octubre
                        (Disposición Adicional Cuadragésima Octava).
                    </p>

                </FormBotonSubmit>


                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default PrestacionModalidadCiclica
